import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpContextToken } from '@angular/common/http';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authenticationService: AuthService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Add bypass option
    if (request.context.get(BYPASS_LOG) === true) 
      return next.handle(request);

    const isFormDataRequest = request.body instanceof FormData;

    // Set headers for all requests
    let headers = request.headers
      .set('Accept', 'application/json')
      .set('Pragma', 'no-cache')
      .set('Cache-control', 'no-cache');

    if (!isFormDataRequest && !headers.has('Content-Type')) {
      headers = headers.set('Content-Type', 'application/json');
    }

    // Set Authorization header with token if user is logged in
    const token = this.authenticationService.token;
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    request = request.clone({
      headers: headers
    });

    return next.handle(request);
  }
}

export const BYPASS_LOG = new HttpContextToken(() => false);